/* 🤖 this file was generated by svg-to-ts */
export const fthrMenu: {
    name: 'fthr-menu';
    data: string;
} = {
    name: 'fthr-menu',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-menu" viewBox="0 0 24 24"><path d="M3 12h18M3 6h18M3 18h18"/></svg>`,
};
